import { getEditor, isEnabled } from '../composables/editorsMap';

import { Pi } from 'lucide-vue-next';
export const getMathKatexOptions = (id: string) => {
  const editor = getEditor(id)?.value;
  return {
    disabled: !isEnabled(id, 'katex'),
    icon: Pi,
    title: 'מקלדת מתמטית',
    action: () =>
      editor
        ?.chain()
        .focus()
        .insertContent('\u200B')
        .focus()
        .insertContent({
          type: 'MathKatexField',
          attrs: {
            'data-katex': true,
            katex: '',
            editMode: true,
          },
        })
        .insertContent('\u200B')
        .focus()
        .run(),
    isActive: () => false,
  };
};
